import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";

declare const window: any;

export default function DetailSelectedContainer({
    detail,
    setMenuSelected,
    setSubMenuSelected,
    setIsSelectedAptoView,
    colors,
    theme,
    setIsTheme,
    setFrame,
    properties,
    hotspotsSelected,
    setHotspotsSelected,
    isPropertyView,
}: any) {
    const [show, setShow] = React.useState("")
    /* React.useEffect(() => {
        const setting_botton: any = document.querySelector(".setting-boton-circular");
        if (setting_botton) {
            setting_botton.style.backgroundColor = colors?.main_buttons;
        }
    }, []) */
    //console.log(detail);
    
    return (
        <div className={`title-detail-container ${theme}`}>
            {
                isPropertyView ? detail : hotspotsSelected?.hotspot_name } | <i className="fas fa-xmark" onClick={() => {
                    if(isPropertyView === false){
                        setMenuSelected("");
                        setSubMenuSelected("");
                        setFrame(1);
                        setHotspotsSelected(null);
                    }
                    setIsSelectedAptoView(null);
                }
                }></i>
        </div>
    );
}
